export { default } from './ModelNameCell'
